import React, { Component } from 'react';
import axios from 'axios';
import { Row, Col, Card, CardImg, CardTitle } from 'reactstrap';
import Swiper from 'react-id-swiper';
import { connect } from "react-redux";
import { FormattedMessage } from 'react-intl';
import { wallpaper_za } from './../../constants/wallpapers_za.js';
import WallpaperPreviewModal from './wallpaperPreviewModal'
import { isGamiclub } from '../../constants/isGamiclub.js';

class Wallpapers extends Component {
    constructor(props) {
        super(props);
        this.state={
            isModalOpen:false,
            selectedImage:null
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }
    handleSelectedImage=(data)=>{
        this.setState({
            selectedImage:data.images_url,
            isModalOpen:true
        })
    }
    onCloseModal=()=>{
        this.setState({
            isModalOpen:false
        })
    }
     downloadImageFromURL=(imageUrl)=> {
        if(imageUrl != null) {
         let imageData = imageUrl.split('/');
         let tempCount = imageData.length;
         let imageName = imageData[tempCount-1];
         axios({
            url: imageUrl,
            method: 'GET',
            responseType: 'blob',
            crossdomain: true 
          }).then((response) => {
             const url = window.URL.createObjectURL(new Blob([response.data]));
             const link = document.createElement('a');
             link.href = url;
             link.setAttribute('download', imageName);
             document.body.appendChild(link);
             link.click();
          })
          .catch(err => {
              console.log('errr------', err);
          })
    
        }
    }
    render() {
        const {selectedImage,isModalOpen} =this.state;
        const gamesParams = {
            direction: 'horizontal',
            slidesPerView: 'auto',
            speed: 500,
        }
        var gameCategoryTitleClass = "game-category-title";
        return (
            <div>
                <WallpaperPreviewModal imageUrl={selectedImage} onCloseModal={this.onCloseModal} isModalOpen={isModalOpen} downloadImageFromURL={this.downloadImageFromURL}/>
                {/* <Row>
                    <div className="category-title-wrap text-uppercase wallpaper-title">
                    <img className="category-title-icon" src="./img/icons/picture.svg" />
                       <span className="category-type">
                                <FormattedMessage id="Wallpapers"
                                    defaultMessage="Wallpapers"
                                />
                            </span>
                          
                    </div>
                </Row> */}
                {wallpaper_za.map((category, index) => {
                    return (
                        <div >
                            <Row >
                                <Col xs="12" className="game-related-container">
                                    <div className="game-related-top">
                                        <div className="game-category" style={isGamiclub ? {borderBottom: '1px solid green'} : null}>
                                            <h2 style={isGamiclub ? {color: 'white', backgroundColor: 'green'} : null} className={gameCategoryTitleClass}><i className="fa fa-picture-o" aria-hidden="true"></i>
                                                <FormattedMessage id={`${category.category_name}`}
                                                    defaultMessage={category.category_name}
                                                />
                                            </h2>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="game-list-row">
                                <Col xs="12">
                                    <Swiper {...gamesParams} shouldSwiperUpdate={true}>
                                        {category.images.map((imageData) => {
                                            return (
                                                <div className="swiper-wallpaper-card" key={imageData.id}>
                                                    <Card className="wallpaper-card"
                                                    onClick={()=>this.handleSelectedImage(imageData)}
                                                    >
                                                        <div className="wallpaper-card-inner">
                                                            <div className="wallpaper-thumb-wrap">
                                                                <CardImg className="wallpaper-thumb" top width="100%" src={imageData.images_url} alt={imageData.title} />
                                                            </div>
                                                            <span className="wallpaper-title">{imageData.title}</span>
                                                            {/* <div className="game-card-details">
                                                        <CardTitle className="game-title text-shadow">{game.gameTitle}</CardTitle>
                                                        <div className="custom-rating isFavorite">
                                                            <input id={'fav'+game.gameId} ref={'star'+game.gameId} className="" type="checkbox" checked={game.isFavorite}/>
                                                            <label htmlFor={'fav'+game.gameId} className="isFavorite">
                                                                <i className="fa fa-star-o custom-star isFavorite"></i>
                                                            </label>
                                                        </div>
                                                        <div className="game-card-left">
                                                            <StarRatingComponent name="rate1" starCount={5} value={game.userRating} editing={false} renderStarIcon={() => <i className="fa fa-star custom-star"></i>}/>
                                                        </div>
                                                        <div className="game-card-right text-uppercase text-shadow text-right">{(game.gameType.toLowerCase() === "html5") ? <i className="fa fa-html5" aria-hidden="true"></i> : <i className="fa fa-android" aria-hidden="true"></i>}</div>
                                                    </div> */}
                                                        </div>
                                                    </Card>
                                                </div>
                                            )
                                        })}
                                    </Swiper>
                                </Col>
                            </Row>
                        </div>
                    )
                })}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        access: state.WelcomeReducer
    };
};


export default connect(mapStateToProps, null)(Wallpapers);



// WEBPACK FOOTER //
// ./src/components/wallpapers/wallpaper.js